import { render, staticRenderFns } from "./IrrigationUpkeepGroups.vue?vue&type=template&id=1e5b6515&scoped=true&lang=html&"
import script from "./IrrigationUpkeepGroups.vue?vue&type=script&lang=js&"
export * from "./IrrigationUpkeepGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5b6515",
  null
  
)

export default component.exports